import { render } from "./H2H.vue?vue&type=template&id=1479b6f4"
import script from "./H2H.vue?vue&type=script&lang=js"
export * from "./H2H.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__